/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Billing_Col_AmountInputs */



/**
* | output |
* | --- |
* | "Amount" |
*
* @param {Sub_Billing_Col_AmountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_billing_col_amount = /** @type {((inputs?: Sub_Billing_Col_AmountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Billing_Col_AmountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Betrag")
	return /** @type {LocalizedString} */ ("Amount")
});